<main
[ngClass]=" {
  'admin-container' : (isLoggedIn$ | async) && isOverviewer && !successScreenRoute(),
  'container' : !isOverviewer,
  'success-route-container' : isOverviewer && successScreenRoute(),
  'no-flex': hasAdminContent && isOverviewer || hasStudentContent && isStudent
}"
>
  <img
  [ngClass]=" (isLoggedIn$ | async) && isOverviewer ? 'admin-bg-image' : 'background-image' "
  ngSrc="{{ backgroundImageUrl }}"  width="auto" height="auto" placeholder [placeholderConfig]="{blur: false}" priority/>
  <ng-content></ng-content>
  <img
    class="powered-by-bbd-image"
    src="../../../../assets/powered-by-bbd.svg"
  />
</main>
